// removed by extract-text-webpack-plugin
module.exports = {"Label":"K2zn_5e7ZEXMDtmGyPZkf","SearchField":"dmAQoY3F_A9v8SVZEpuU2","WithMagnifier":"_1woc5-0mdFYyUux6KFZys2","fullWidth":"POYalZPOT5Vo5Z_XpGSuv","error":"_2-TL7JmxaBJfoVlCgyAfTR","ErrorText":"_34n9kSnRdzTRSuRzL9d6L2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchField/index.css
// module id = 843
// module chunks = 0